import { makeStyles } from '@material-ui/core'
import Colors from '../../constants/Colors'

export default makeStyles(theme => ({
  root: {
    width: '40px',
    height: '40px',
    borderRadius: 50,
  },
  colorPrimary: {
    width: '40px',
    height: '40px',
    borderRadius: 50,
    color: Colors.DISABLED_COLOR,
  },
  emptyPicture: {
    height: ' 100%',
    width: ' 100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}))
